import type { ISession } from '../session/interface/session';

type AssetResolver = (mediumId: string, workspace: ISession) => Promise<string>;

export async function _cacheResolver(mediumId: string, workspace: ISession) {
    const isCached = await workspace.media.isMediumCached(mediumId);

    if (isCached) {
        /* let the service-worker resolve the cache hit, just return the original url */
        const blob = await workspace.media.downloadToBinary(mediumId, 'Blob', true);

        if (blob.size <= 0 || blob.type === '') {
            /* opaque response, we have the object from the service, worker. However we can't serve it. Let the service worker deal with it */
            const url = await workspace.media.resolveUrlWithToken(mediumId);
            return url;
        } else {
            const url = URL.createObjectURL(blob);
            return url;
        }
    } else {
        return Promise.reject(`Missing cache for asset`);
    }
}

async function _urlWithTokenResolver(mediumId: string, workspace: ISession) {
    return workspace.media.resolveUrlWithToken(mediumId);
}

export async function lazyUrlForAsset(
    mediumId: string,
    workspace: ISession,
    resolver: AssetResolver | AssetResolver[] = [],
) {
    if (!mediumId || !workspace) {
        return '';
    }

    const resolvers: Array<AssetResolver> = [
        _cacheResolver,
        ...(Array.isArray(resolver) ? resolver : [resolver]),
        _urlWithTokenResolver,
    ];

    for (const resolver of resolvers) {
        const url = await resolver(mediumId, workspace).catch(() => undefined);
        if (url) {
            return url;
        }
    }

    throw new Error(`Unable to resolve lazyUrl for: ${mediumId}`);
}
